<template>
    <button class="button" 
      :style="{ width: width }"
      :class="[size]" 
      :disabled="disabled"
      :hover="hover"
      v-on:click="onClick">      
      {{ label }}    
      <slot></slot>
    </button>      
</template>

<script>
export default {
  name: 'BaseButton',   
  props: {
    label: {
      type: String, 
      default: "button"
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hover: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    width: {
      type: String,
      default: ''
    }, 
  },
  methods: {
    onClick() {      
      this.$emit("onClick");      
    },
  },
}
</script>

<style scoped>
  .button {
    box-sizing: border-box;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    border: 1px solid var(--Theme-Primary);
    background-color: var(--Theme-Primary);
    
    color: var(--Gray-White);
    /* font-family: 'Helvetica Neue', sans-serif; */
    font-family: 'GingerFont', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;   
  }

  .button:hover{
    border-radius: 4px;
    border: 1px solid var(--components-button-primary-hovered-border);
    background-color: var(--components-button-primary-hovered-background);
  }
  .button:active{
    border: 1px solid var(--components-button-primary-active-border);
    background: var(--components-button-primary-active-background);
  }
  .button:disabled {
    opacity: 0.65;
    background: var(--components-button-primary-hovered-background, #CED4DA); 
    border: 1px solid var(--Gray-400, #CED4DA);
  }   
  .small{
    padding: 4px 8px;
    border-radius: 3.2px;
    height: 31px;
    width: 95px;
    font-size: 14px;
  }
  .medium{
    padding: 6px 12px;
    height: 35px;
    width: 103px;
    border-radius: 4px;
  }
  .large{
    padding: 8px 16px;
    border-radius: 4.8px;
    height: 48px;
    width: 143px;
    font-size: 20px;
  }
</style>